/**
 * useShimmer — shared hook for the Skeleton family.
 *
 * Returns `true` when shimmer animations should play, `false` when
 * the user has enabled `prefers-reduced-motion: reduce`.
 *
 * @see specs/integration-plan.md Section 5.1
 */
import { useState, useEffect } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function canMatchMedia(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}

export function useShimmer(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => {
    if (!canMatchMedia()) return true;
    return !window.matchMedia(QUERY).matches;
  });

  useEffect(() => {
    if (!canMatchMedia()) return;
    const mql = window.matchMedia(QUERY);
    const handler = (e: MediaQueryListEvent) => setEnabled(!e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, []);

  return enabled;
}
